export default "__VITE_ASSET__V0IKfXX___"